import React from "react";
const Asm = () => {
    return (
    <div>
        <h2>Example assembly code to render the animated sprite</h2>
        <hr/ >
; deltes the srpite which is 16 line height 3 bites wide<br />
; c, x coordinate<br />
; d, y coorinate <br />
<br />
delete_sprite:<br />
&nbsp;&nbsp;&nbsp;&nbsp;call yx2pix&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;point de at the corresponding screen address<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld b,16&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;sprite is 16 lines high<br />
delete_sprite_loop:<br />
&nbsp;&nbsp;&nbsp;&nbsp;xor a&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;empty a to delete<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld (de),a&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;repeat a total of 3 times<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc e&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;next column along<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld (de),a<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc e<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld (de),a<br />
&nbsp;&nbsp;&nbsp;&nbsp;dec e<br />
&nbsp;&nbsp;&nbsp;&nbsp;dec e&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;move de back to start of line<br />
&nbsp;&nbsp;&nbsp;&nbsp;call get_next_line&nbsp;&nbsp;&nbsp;&nbsp;;move de down one line<br />
&nbsp;&nbsp;&nbsp;&nbsp;djnz delete_sprite_loop&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;repeat 16 times<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret<br />
<br />
draw_static_sprite:<br />
&nbsp;&nbsp;&nbsp;&nbsp;push hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;call yx2pix<br />
&nbsp;&nbsp;&nbsp;&nbsp;pop hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld b,8<br />
&nbsp;&nbsp;&nbsp;&nbsp;jp draw_loop<br />
<br />
; draw sprite<br />
; c x coordinate<br />
; b y coordinate<br />
; hl points to first stripe frame in memory<br />
draw_sprite:<br />
&nbsp;&nbsp;&nbsp;&nbsp;push bc<br />
&nbsp;&nbsp;&nbsp;&nbsp;call yx2pix<br />
&nbsp;&nbsp;&nbsp;&nbsp;pop bc<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,c<br />
&nbsp;&nbsp;&nbsp;&nbsp;; chose image by frame index in a<br />
&nbsp;&nbsp;&nbsp;&nbsp;and 00000111b<br />
&nbsp;&nbsp;&nbsp;&nbsp;call get_sprite<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld b,16<br />
draw_loop:<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,(hl)<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld (de),a<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc e<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,(hl)<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld (de),a<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc e<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,(hl)<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld (de),a<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;dec e<br />
&nbsp;&nbsp;&nbsp;&nbsp;dec e<br />
&nbsp;&nbsp;&nbsp;&nbsp;call get_next_line<br />
&nbsp;&nbsp;&nbsp;&nbsp;djnz draw_loop<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret<br />
&nbsp;&nbsp;&nbsp;&nbsp;<br />
; register de contains current line<br />
get_next_line:<br />
&nbsp;&nbsp;&nbsp;&nbsp;inc d<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,d<br />
&nbsp;&nbsp;&nbsp;&nbsp;and 7<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret nz<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,e<br />
&nbsp;&nbsp;&nbsp;&nbsp;add a,32<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld e,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret c<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,d<br />
&nbsp;&nbsp;&nbsp;&nbsp;sub 8<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld d,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret<br />
&nbsp;&nbsp;&nbsp;&nbsp;<br />
; b=y, 0-192<br />
; c=x, 0-255<br />
; return position on screen id de<br />
yx2pix:<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,b<br />
&nbsp;&nbsp;&nbsp;&nbsp;rra<br />
&nbsp;&nbsp;&nbsp;&nbsp;rra<br />
&nbsp;&nbsp;&nbsp;&nbsp;rra<br />
&nbsp;&nbsp;&nbsp;&nbsp;and 24<br />
&nbsp;&nbsp;&nbsp;&nbsp;or 64<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld d,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,b<br />
&nbsp;&nbsp;&nbsp;&nbsp;and 7<br />
&nbsp;&nbsp;&nbsp;&nbsp;or d<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld d,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,b<br />
&nbsp;&nbsp;&nbsp;&nbsp;rla<br />
&nbsp;&nbsp;&nbsp;&nbsp;rla<br />
&nbsp;&nbsp;&nbsp;&nbsp;and 224<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld e,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld a,c<br />
&nbsp;&nbsp;&nbsp;&nbsp;rra<br />
&nbsp;&nbsp;&nbsp;&nbsp;rra<br />
&nbsp;&nbsp;&nbsp;&nbsp;rra<br />
&nbsp;&nbsp;&nbsp;&nbsp;and 31<br />
&nbsp;&nbsp;&nbsp;&nbsp;or e<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld e,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret<br />
&nbsp;&nbsp;&nbsp;&nbsp;<br />
; input a frame indes<br />
; hl first frame address<br />
; return hl pointing to the selected sprite rotated by 0-7 (a)<br />
get_sprite:<br />
&nbsp;&nbsp;&nbsp;&nbsp;push hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld h,0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld l,a<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld b,h<br />
&nbsp;&nbsp;&nbsp;&nbsp;ld c,l<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,hl<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,bc<br />
&nbsp;&nbsp;&nbsp;&nbsp;pop bc<br />
&nbsp;&nbsp;&nbsp;&nbsp;add hl,bc<br />
&nbsp;&nbsp;&nbsp;&nbsp;ret<br />
    </div>
  );
};

export default Asm;
